import React from 'react';
import { WHP_PALETTE } from '../../lib/whpColors';
import { LegendCard } from './LegendCard';
import { CategoricalLegend } from './CategoricalLegend';

/**
 * Floating legend for the Wildfire Hazard Potential map overlay. The overlay
 * is colored by each pixel's national WHP class (same 5-bucket classification
 * the left-panel bar chart uses), so the legend is a simple categorical
 * swatch list.
 */
export const WhpMapLegend: React.FC = () => (
  <LegendCard title="WHP class — national" positioned>
    <CategoricalLegend palette={WHP_PALETTE} />
  </LegendCard>
);
